// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kaSb","colMin":"styles_colMin__3YXKJ"};